import { Badge, Tooltip, useClipboard } from '@chakra-ui/react';
import type { BlockchainEndpointResponse } from '@web/dto/rpc/blockchainEndpointResponse';
import { useCallback, useEffect } from 'react';
import { useInstance } from '../../../domain/hook/useInstance';
import { NotificationService } from '../../../domain/service/NotificationService';
import { UrlService } from '../../../domain/service/UrlService';

interface IProps {
  readonly blockchainEndpoint: BlockchainEndpointResponse;
}

export function BlockchainEndpointUrl(props: IProps) {
  const urlService = useInstance(UrlService);
  const url = urlService.createBlockchainEndpointUrl(props.blockchainEndpoint.accessToken);
  const { onCopy, setValue } = useClipboard(url ?? 'empty');
  const notification = useInstance(NotificationService);

  useEffect(() => {
    setValue(url);
  }, [url, setValue]);

  const copy = useCallback(() => {
    onCopy();
    notification.success('Success', 'Url copied to clipboard');
  }, [onCopy, notification]);

  return (
    <Tooltip label="Click to copy">
      <Badge
        cursor="pointer"
        fontSize="sm"
        onClick={copy}
        textTransform="none"
        whiteSpace="normal"
        wordBreak="break-word"
      >
        {url}
      </Badge>
    </Tooltip>
  );
}
